export default __webpack_public_path__ + "static/media/bannerBig7.2db0fab7.png";